import { CSSProperties, FC } from 'react';
import Image from 'react-graceful-image';

interface ImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

const CImage: FC<ImageProps> = (props) => {
  return <Image {...props} />;
};

export default CImage;
